import React from "react";
import { Search } from "lucide-react"; // Better icon
import "./SearchInput.css";

interface SearchInputProps {
  searchText: string;
  setSearchText: (text: string) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({ searchText, setSearchText }) => {
  return (
    <div className="search-container">
      <input
        type="text"
        placeholder="Search items..."
        className="custom-search-input"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        aria-label="Search"
      />
      <span className="search-icon">
        <Search size={18} strokeWidth={1.8} />
      </span>
    </div>
  );
};

export default SearchInput;
